<template>
  <div v-if="loaded" id="fourth_step" class="form-step-container">
    <!-- תגית השלב והכותרת -->
    <div class="step-badge" v-html="words.step + ' ' + step"></div>
    <h1 class="main-title" v-html="words.where_to_send_invoice"></h1>

    <form class="form_steps" @submit.prevent="openUser()">
      <!-- כרטיסייה 1: בחירת אופן קבלת חשבונית -->
      <div class="card-box">
        <div class="invoice_wrapper">
          <div 
            class="option" 
            :class="{ active: form.invoice == 0 }" 
            @click="form.invoice = 0"
          >
            <div class="radio_circle"></div>
            <div class="option_content">
              <div class="small_title bold" v-html="words.by_email"></div>
              <div class="value semi_bold">
                <span>{{ email }}</span>
                <button 
                  type="button" 
                  class="change_number semi_bold" 
                  @click.stop="$emit('goToStep', 2)" 
                  v-html="words.change_number"
                ></button>
              </div>
            </div>
          </div>

          <div 
            class="option" 
            :class="{ active: form.invoice == 1 }" 
            @click="form.invoice = 1"
          >
            <div class="radio_circle"></div>
            <div class="option_content">
              <div class="small_title bold" v-html="words.by_user_area"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- כרטיסייה 2: תנאי שימוש וחתימה -->
      <div class="card-box">
        <div class="terms_section">
          <div class="terms_block">
            <h4 class="inner_title" v-html="words.read_terms"></h4>
            <div class="pdf_wrapper" v-html="terms"></div>
          </div>

          <div class="sig_wrapper">
            <div class="sig_header">
              <h4 class="inner_title" v-html="words.sign_terms"></h4>
              <button 
                type="button" 
                class="btn_clear_sig" 
                @click="clearSig" 
                v-html="words.clear_signature"
              ></button>
            </div>

            <div class="sig_pad_container">
              <SignaturePad 
                ref="signaturePad" 
                :width="420" 
                :height="110" 
                :custom-style="sigPadStyle" 
                @input="singChange" 
              />
            </div>
          </div>
        </div>
      </div>

      <!-- סרגל כפתורי פעולה בתחתית -->
      <div class="action-footer">
        <button 
          type="button" 
          class="btn-back" 
          tabindex="0" 
          @click="$emit('returnStep')"
        >
          ➔ <span v-html="words.return_step"></span>
        </button>

        <input 
          type="submit" 
          class="btn-primary" 
          :class="{ disabled: !isOkToSubmit }" 
          :disabled="!isOkToSubmit" 
          :value="words.procced" 
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    numbersInfo: { required: true, type: Array },
    step: { required: true, type: Number },
    numbers: { required: true, type: Array },
    skipPay: { required: true, type: Boolean },
    phone: { required: true, type: String },
    email: { required: true, type: String }
  },
  data() {
    return {
      form: {
        invoice: 0 // 0 = email, 1 = user area
      },
      isLoading: false,
      terms: '',
      isOkToSubmit: false,
      loaded: false,
      numOfPages: 0,
      sigPadStyle: {
        width: '100%',
        height: '110px',
        borderRadius: '12px'
      }
    }
  },
  computed: {
    words() {
      return this.$store.state.words || {}
    }
  },
  mounted() {
    this.$store.commit('setIsLoading', { isLoading: true })

    this.api({ action: 'get_terms', data: {} }, (data) => {
      this.terms = data.data.text
      this.loaded = true
      this.$store.commit('setIsLoading', { isLoading: false })
    })
  },
  methods: {
    urltoFile(url, filename, mimeType) {
      mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1]
      return fetch(url)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
    },
    onSelectCity() {
      this.openStreet = true
      this.api({ action: 'cart/save_city', data: { city: this.selectedCity } })
    },
    singChange() {
      this.isOkToSubmit = true
    },
    openUser() {
      this.$store.commit('setIsLoading', { isLoading: true })
      if (this.$refs.signaturePad.isEmpty()) {
        this.activateError(this.words.signature_requierd)
      } else {
        const { data } = this.$refs.signaturePad.saveSignature()
        const formData = { signature: data, ...this.form }
        this.$emit('saveData', formData, true)

        this.api({ action: 'api/add_account', data: {} }, (data) => {
          if (data.data.error && data.data.error !== '') {
            this.activateError(data.data.error)
            return this.$store.commit('setIsLoading', { isLoading: false })
          } else if (data.data && !this.skipPay) {
            this.$emit('goToStep', this.step + 1)
            window.scrollTo(0, 0)
          }
        })
      }
      this.$store.commit('setIsLoading', { isLoading: false })
    },
    saveDidsToAccount() {
      const { data } = this.$refs.signaturePad.saveSignature()
      const formData = { signature: data }
      this.$emit('saveData', formData, true)
      this.api({ action: 'api/save_dids_to_account' }, (data) => {
        if (data.data.error && data.data.error !== '') {
          this.activateError(data.data.error)
          this.$store.commit('setIsLoading', { isLoading: false })
        } else {
          document.location = '/activate'
        }
        this.$emit('saveData', false)
      })
    },
    clearSig() {
      this.$refs.signaturePad.clearSignature()
      this.isOkToSubmit = false
    }
  },
  watch: {
    isOkToSubmit() {
      return true
    }
  }
}
</script>

<style lang="scss" scoped>

$purple-primary: #6B11D8;
$purple-light: #F5EFFF;
$purple-hover: #550bb1;
$bg-light: #F8F9FD;
$text-dark: #2B2635;
$text-muted: #718096;
$border-color: #E2E8F0;
$danger-color: #E53E3E;
$danger-bg-hover: #FFF5F5;
$disabled-bg: #CBD5E0;
$radius: 16px;

.form-step-container {
  direction: rtl;
  text-align: right;
  font-family: inherit;

  /* התאמה לגובה המסך ומניעת גלילה מיותרת */
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

 .step-badge {
  display: block;
  width: 100%;               /* מותח את הרקע לרוחב כל השורה */
  box-sizing: border-box;
  background: #F5EFFF;       /* רקע סגול בהיר */
  color: #6B11D8;            /* צבע טקסט סגול */
  font-size: 13px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 20px;
  margin-bottom: 12px;
  text-align: right;         /* יישור הטקסט לימין */
}

  .main-title {
    font-size: 22px;
    font-weight: 800;
    color: $text-dark;
    margin: 0 0 12px 0;
  }

  .form_steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    justify-content: space-between;
  }

  /* כרטיסיות עיצוב */
  .card-box {
    background: #ffffff;
    border: 1px solid $border-color;
    border-radius: $radius;
    padding: 14px 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  }

  /* בחירת אופן קבלת חשבונית */
  .invoice_wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;

    .option {
      border: 1.5px solid $border-color;
      border-radius: 12px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      background-color: #ffffff;
      transition: all 0.2s ease;

      &:hover {
        border-color: $purple-primary;
        background-color: $purple-light;
      }

      &.active {
        border-color: $purple-primary;
        background-color: $purple-light;

        .radio_circle {
          border-color: $purple-primary;

          &::after {
            opacity: 1;
            transform: scale(1);
          }
        }
      }

      .radio_circle {
        width: 18px;
        height: 18px;
        min-width: 18px;
        border: 2px solid $border-color;
        border-radius: 50%;
        position: relative;
        transition: border-color 0.2s ease;

        &::after {
          content: '';
          width: 8px;
          height: 8px;
          background-color: $purple-primary;
          border-radius: 50%;
          position: absolute;
          top: 3px;
          right: 3px;
          opacity: 0;
          transform: scale(0);
          transition: transform 0.2s ease, opacity 0.2s ease;
        }
      }

      .option_content {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .small_title {
          font-size: 13px;
          font-weight: 700;
          color: $text-dark;
        }

        .value {
          font-size: 12px;
          color: $text-muted;
          display: flex;
          align-items: center;
          gap: 6px;

          .change_number {
            background: none;
            border: none;
            color: $purple-primary;
            text-decoration: underline;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            padding: 0;
            transition: color 0.2s ease;

            &:hover {
              color: $purple-hover;
            }
          }
        }
      }
    }
  }

  /* תנאים וחתימה */
  .terms_section {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .inner_title {
      font-size: 13px;
      font-weight: 700;
      color: $text-dark;
      margin: 0 0 6px 0;
    }

    .pdf_wrapper {
      background-color: $bg-light;
      border: 1px solid $border-color;
      border-radius: 10px;
      padding: 10px;
      max-height: 100px;
      overflow-y: auto;
      font-size: 12px;
      line-height: 1.5;
      color: #4A5568;

      scrollbar-width: thin;
      scrollbar-color: $border-color transparent;

      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $border-color;
        border-radius: 4px;
      }
    }

    .sig_wrapper {
      display: flex;
      flex-direction: column;

      .sig_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;

        .btn_clear_sig {
          background: none;
          border: none;
          color: $danger-color;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          padding: 2px 6px;
          border-radius: 4px;
          transition: background-color 0.2s ease;

          &:hover {
            background-color: $danger-bg-hover;
          }
        }
      }

      .sig_pad_container {
        border: 1.5px dashed $border-color;
        border-radius: 12px;
        background-color: #ffffff;
        overflow: hidden;
        transition: border-color 0.2s ease;

        &:focus-within,
        &:hover {
          border-color: $purple-primary;
        }
      }
    }
  }

  /* סרגל כפתורים בתחתית */
  .action-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: auto;
    padding-top: 10px;

    .btn-back {
      background: transparent;
      border: none;
      color: $text-muted;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 20px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;

      &:hover {
        color: $purple-primary;
        background-color: $purple-light;
      }
    }

    .btn-primary {
      border: none;
      background: $purple-primary;
      color: #ffffff;
      padding: 10px 24px;
      border-radius: 30px;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 4px 12px rgba(107, 17, 216, 0.2);

      &:hover:not(.disabled):not(:disabled) {
        background: $purple-hover;
        box-shadow: 0 6px 16px rgba(107, 17, 216, 0.3);
      }

      &.disabled,
      &:disabled {
        background-color: $disabled-bg;
        box-shadow: none;
        cursor: not-allowed;
      }
    }
  }
}
</style>